import React from "react"
import debounce from "lodash/debounce"
import classNames from "classnames"
import PostCard from "../PostCard/PostCard"
// import { get } from '../../utilities/get.js';
import { UserDataContext } from "../../context/UserDataContext"
import "./main.scss"
import { get } from "../../utilities/get"

const Main = () => {
  const [userData] = React.useContext(UserDataContext)
  //
  const [isMessageReveled, setMessageReveled] = React.useState(false)
  // TODO: Add logic reporting full scroll event
  // const [isBottomReached, setBottomReached] = React.useState(false)
  const message = React.useRef()

  // TODO: This works, if the ID is not dynamic. So maybe it need to be async with a loader in the future.
  // TODO: We should also abstract the first segment f the URL so it work locally and on the remote server with editing.
  /*  React.useEffect(() => {
    // get data from GitHub api
    // fetch(`https://api.github.com/repos/gatsbyjs/gatsby`)
    fetch(`http://christmas-2001.gd:8888/static/log/FirstName.php?u=${userData.id}`)
      .then(response => response.json()) // parse JSON from request
      .then(resultData => {
        // setStarsCount(resultData.stargazers_count)
        console.log(resultData)
      }) // set data for the number of stars
  }, []) */

  React.useLayoutEffect(() => {
    const calcMessageReveal = () => {
      const { pageYOffset } = window
      const pageInnerHeight = window.innerHeight
      const messageYOffset = message.current.getBoundingClientRect().top
      // console.log('window.pageYOffset: ' + window.pageYOffset)
      // console.log('window.innerHeight: ' + window.innerHeight)

      if (messageYOffset < pageYOffset + pageInnerHeight) {
        setMessageReveled(true)
      } else {
        setMessageReveled(false)
      }
    }

    const scrollEventDebouncer = debounce(() => {
      calcMessageReveal()
    }, 100)

    if (typeof window !== "undefined") {
      window.addEventListener("load", calcMessageReveal())
      window.addEventListener("scroll", scrollEventDebouncer)
      window.addEventListener("resize", scrollEventDebouncer)
    }
    // Remove listener (like componentWillUnmount)
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("load", calcMessageReveal())
        window.removeEventListener("scroll", scrollEventDebouncer)
        window.removeEventListener("resize", scrollEventDebouncer)
      }
    }
  }, [])

  const coraCookieClick = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=cora cookie clicked`)
  }
  const opened2024 = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=opened 2024`)
  }
  const opened2023 = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=opened 2023`)
  }
  const opened2022 = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=opened 2022`)
  }
  const opened2021 = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=opened 2021`)
  }
  const opened2020 = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=opened 2020`)
  }

/*   const lilyCookieClick = () => {
    get(`static/log/LogEvent.php?u=${userData.id}&e=lily cookie clicked`)
  } */
  return (
    <main className="Main">
      <div className="Main-postCard">
        <div className="Main-postCardInner">
          <PostCard />
        </div>
      </div>
      <div className="Main-message">
        <div
          ref={message}
          className={classNames("Main-messageInner", {
            "is-visible": isMessageReveled === true,
          })}
        >
          <p>Hello friends! 👋</p>

          <p>It&apos;s not you. It&apos;s us.  Sorry for the late card this year.</p>

          <p>Where to begin… oh, yeah. The kids!</p>

          <p>We can&apos;t believe it, but Cora (13) is in her last year of middle school. She&apos;s doing great with her studies as always.  Last winter she took up running and joined the spring track team 🏃‍♀️‍➡️.  Meanwhile she continues playing volleyball 🏐 for the HMS 8th grade team and CMass. Go Cora! Once again, she would be happy {" "}
            <a
              href="https://digitalcookie.girlscouts.org/scout/cora941460"
              target="_blank"
              rel="noreferrer"
              onClick={() => coraCookieClick()}
            >take your girl scout cookie order 🍪
              {" "}</a>
            (yes, we deliver nearby!).</p>

              <p>Lily (11) is in her first year of middle school and it is suiting her well academically and socially.  She plays soccer ⚽️ year-round for her travel, indoor and club teams.  She continues to study violin in school. This winter she resumed travel basketball 🏀 and is known to dunk verbally on her parents 6-7 times a day.</p>

              <p>Jenna&apos;s enjoyed her first full year as an independent branding consultant.  It&apos;s been a busy and fun year working with an array of interesting clients in the region.  As per usual, Jenna can be found volunteering with Cora&apos;s Girls Scout troop and enjoying yoga and dance fusion classes when she gets a break.</p>

              <p>John enjoyed another year with UX consultancy ZeroDegrees, saving his evenings for his real passion – driving the kiddos to all their activities.  Inspired by Cora, John took up running again in 2025 and continues to play and coach volleyball.</p>

              <p>On a tragic note, we said goodbye to our beloved cat Finn in August. He will always be in our hearts.  This Christmas we welcomed two new kittens into the family – Ralphie and Buddy.  Yes, named after two of our favorite Christmas characters.</p>

              <p>Peace and love to all,</p>
              <p>- John, Jenna, Cora, Lily Ralphie 🐾 and Buddy 🐾
              <br/>69 W Elm St, Hopkinton MA 01748</p>

              <h2><strong>FAQs</strong></h2>
              <div className='Faq'>
                <p className='Faq-q'><strong>Q:</strong> Why am I getting an eCard? Do the Gavula&apos;s not like me enough to send me a real card in the mail?</p>
                <p className='Faq-a'><strong>A:</strong> You are not a second-tier friend or family member. We only do an eCard and have done so for many years… (
                  <a
                  href="http://christmas.2024.gavuladesign.com"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => opened2024()}
                >2024
                  </a>,{" "}
                  <a
                    href="http://christmas.2023.gavuladesign.com"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => opened2023()}
                  >2023
                  </a>,{" "}
                  <a
                    href="http://christmas.2022.gavuladesign.com"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => opened2022()}
                  >2022
                  </a>,{" "}
                  <a
                    href="http://christmas.2021.gavuladesign.com"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => opened2021()}
                  >2021
                  </a>,{" "}
                  <a
                    href="http://christmas.2020.gavuladesign.com"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => opened2020()}
                  >2020
                  </a>
                  )</p>
              </div>
              <div className='Faq'>
                <p className='Faq-q'><strong>Q:</strong> Why is your card late? Did you forget about me?</p>
                <p className='Faq-a'><strong>A:</strong> We didn’t forget you. John is just slow and busy. He should probably just have AI do it, but this production is homemade. Every year we mean to update the template or get started earlier. Maybe this will be the one?</p>
              </div>
        </div>
      </div>
    </main>
  )
}

export default Main
